import { Redirect } from "react-router";
import React from "react";
import Decrypt from "./Decryption";
import Encrypt from "./Encryption";
import { checkPermission } from "../helpers/PageAccess/CheckPermission";
import { deleteCookie, deleteLocalStorage } from "../helpers/Context/Context";
import { toast } from "react-toastify";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const invokeApi = async (
  url,
  { method, headers, payload, isFormData, isLogin }
) => {
  if (!payload) {
    payload = {};
  }
  // let bodyData = JSON.stringify(payload);

  let pathName = window.location.hash;

  const permissionName = checkPermission(pathName);
  const userRoleValue = getFromEncLocalStorage("userRole");

  console.log("pathName payload: ", pathName);
  console.log("permissionName payload: ", permissionName);

  try {
    payload.employeenumber = getFromEncLocalStorage("employeenumber");
    payload.firstname = getFromEncLocalStorage("firstname");
    payload.lastname = getFromEncLocalStorage("lastname");
    payload.empDeptName = getFromEncLocalStorage("empDeptName");
    payload.nameofposition = getFromEncLocalStorage("nameofposition");
    payload.userIdForSession = getFromEncLocalStorage("userId");
    payload.permissionName = permissionName;
    payload.userLoggedInAsPermission = userRoleValue || "";
    payload.platform = "Web";
  } catch (err) { }

  let encryptedData = {
    // data: Encrypt(JSON.stringify({ data: payload, encryptionType: true })), Old method
    data: Encrypt(JSON.stringify(payload)),
  };
  var newBodyData = isLogin ? payload : JSON.stringify(encryptedData);
  //}
  const response = await fetch(url, {
    method,
    headers: {
      ...headers,
    },
    body: isFormData ? payload : newBodyData,
  });

  const data = await response.json();
  if (data.message === "INVALIDUSER") {
    if (confirm("Session expired, please login again")) {
      deleteCookie("ApplicationToken");
      deleteLocalStorage();
      window.location.href = `${window.location.origin}/login`;
    }
  } else if (data.message === "Unauthorized") {
    if (confirm("Something went wrong, please login again")) {
      deleteCookie("ApplicationToken");
      deleteLocalStorage();
      window.location.href = `${window.location.origin}/login`;
    }
  } else if (response.status !== 200) {
    if (data.message == "Special characters not allowed") {
      toast(data.message);
    }
    return false;
  } else {
    // let newData = isLogin ? data : JSON.parse(Decrypt(data.data));
    let newData = isLogin
      ? data
      : typeof data.data !== "object"
        ? JSON.parse(Decrypt(data.data))
        : data.data;

    return newData;
  }
};
